/* eslint-disable react/prop-types */
import React from 'react'

import { FORBES1_THEME, FOX1_THEME, INSIDER_THEME, NYPOST_THEME, WSJ_THEME } from 'common/constants'
import Nmls, { PAID_AD_TEXT } from 'components/nmls'
import AdvertisementText from 'components/advertisement-text'

import BelowCtaWsj from './content/themes/wsj/BelowCta'
import styles from './content/themes/wsj/styles.module.scss'

const Noop = () => {}

const simpleCtaConfig = {
  [WSJ_THEME]: {
    AboveCta: () => <AdvertisementText className={styles.header} placement="right" />,
    BelowCta: BelowCtaWsj,
    Nmls: Noop,
  },
  [FORBES1_THEME]: {
    Nmls: ({ show }) => <Nmls show={show} text={PAID_AD_TEXT} />,
  },
  [FOX1_THEME]: {
    Nmls: ({ show }) => <Nmls show={show} text={PAID_AD_TEXT} />,
  },
  [INSIDER_THEME]: {
    Nmls: ({ show }) => <Nmls show={show} text={PAID_AD_TEXT} />,
  },
  [NYPOST_THEME]: {
    Nmls: ({ show }) => <Nmls show={show} text={PAID_AD_TEXT} />,
  },
  default: {
    AboveCta: Noop,
    BelowCta: Noop,
    Nmls: ({ show }) => <Nmls show={show} />,
  },
}

export default simpleCtaConfig
